module.exports = function getResource(label, vars = []) {
    let resources = {
        privateContent: 'Contenu privé',
        exploreAll: 'Explorer tout',
        viewAll: 'Tout afficher'
    };
    return resources[label];
};
